<div class="selector-wrap">
  <capra-icon icon="{{ entitlementIcon }}"></capra-icon>
  <div class="selector">
    <span>
      <span class="label">Default Workspace access:</span>

      <mode-default-access-inline-toast [placement]="'right'">
        <mode-access-selector
          [isContentPersonal]="isContentPersonal"
          [selected]="selected"
          [type]="'workspace'"
          (selection)="entitlementChange($event)"
        ></mode-access-selector>
      </mode-default-access-inline-toast>
    </span>
    <p class="description">
      <span>{{ selectedItem.description }}</span
      >&nbsp;
      <span *ngIf="!isContentPersonal; else personalContentDescription"
        ><a
          [attr.href]="helpDocs.links['https://mode.com/help/articles/permissions/#set-up-connection-permissions']"
          target="_blank"
          >Data source permissions</a
        >
        may impact access.</span
      >
      <ng-template #personalContentDescription>
        <a [attr.href]="helpDocs.links['https://mode.com/help/articles/spaces/#personal-collection']" target="_blank"
          >Personal content</a
        >
        is not searchable by other Members.
      </ng-template>
    </p>
  </div>
</div>
